import React from 'react';
import { Route } from 'react-router-dom';
import CommunityDetails from './CommunityDetails';

const CommunityScene = () => (
  <>
    <Route
      exact
      path="/community/:tab?/:action?/:actionId?"
      component={CommunityDetails}
      menuName="communities"
    />
  </>
);

export default CommunityScene;
